import React from 'react'

const Sponsors = ({sponsors}) => {

  if(!sponsors) return ( <></> )

  return (
    <>

      <div className="sidebar-widget" id="tourney-overview">
        <h3>Tournament Sponsors</h3>
          <div id='#tournament-sponsors' dangerouslySetInnerHTML={{ __html:sponsors }} />
      </div> 

    </>
  )

  
}

export default Sponsors